import { keyframes } from 'styled-components';

import type { PolyLoaderConfig } from './PolyLoaderConfig';

export const wave = (config: PolyLoaderConfig) => keyframes`
  0%   { transform: scale(1); fill: ${config.fill}; stroke: ${config.stroke}; filter: opacity(1)}
  10%  { transform: scale(1.08); fill: ${config.fill}; stroke: ${config.stroke}; filter: opacity(0.9) }
  20%  { transform: scale(1.15); fill: ${config.fillActive}; stroke: ${config.strokeActive}; filter: opacity(1)}
  40%  { transform: scale(1.08); fill: ${config.fillActive}; stroke: ${config.strokeActive}; filter: opacity(0.9) }
  80%  { transform: scale(1); fill: ${config.fill}; stroke: ${config.stroke}; filter: opacity(1)}
  100% { transform: scale(1); fill: ${config.fill}; stroke: ${config.stroke}; filter: opacity(1)}
`;
